import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const REVALIDATE_MS = 30_000;

const FALLBACK = {
  isPresaleActive: false,
  tokenPrice: null,
  tokensSold: null,
  totalTokens: null,
  percentSold: null,
  saleEndsAt: null,
  chainsLive: ['ETH', 'BSC', 'TRON'],
};

function shape(payload) {
  const round = payload?.activeRound;
  return {
    isPresaleActive: Boolean(payload?.isPresaleActive),
    tokenPrice: round?.tokenPrice ?? null,
    tokensSold: round?.tokensSold ?? null,
    totalTokens: round?.totalTokens ?? null,
    percentSold: typeof round?.percentSold === 'number' ? round.percentSold : null,
    saleEndsAt: round?.endDate ?? payload?.countdown?.endDate ?? null,
    chainsLive: ['ETH', 'BSC', 'TRON'],
  };
}

export default function usePublicPresaleStats() {
  const [data, setData] = useState(FALLBACK);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        // public-stats is the unauthenticated endpoint — /info sits behind the
        // Clerk gate, so signed-out visitors on the landing page can't use it.
        const res = await axios.get(`${API_BASE_URL}/presale/v2/public-stats`, { timeout: 8000 });
        if (cancelled) return;
        if (res.data?.success) {
          setData(shape(res.data));
          setStatus('ready');
        } else {
          setStatus('fallback');
        }
      } catch (_err) {
        if (cancelled) return;
        setStatus('fallback');
      }
    }

    load();
    const id = setInterval(load, REVALIDATE_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return { stats: data, status };
}
